module.exports = __webpack_public_path__ + "static/media/G1-30-Ataque-Inesperado-da-Arqueira-cod61.3673873a.png";